import React from 'react';
import  BaseIcon  from '@/components/icons/BaseIcon';

interface ChevronDownIconProps {
  className?: string;
}

const ChevronDownIcon: React.FC<ChevronDownIconProps> = ({ className }) => (
  <BaseIcon className={className}>
    <path d="m6 9 6 6 6-6" />
  </BaseIcon>
);

export default ChevronDownIcon;
